import React, { useContext, useEffect, useState } from 'react';
import "./aircraftTypeItem.css";
import { Popover, Tooltip } from '@mui/material';
import { Dropdowns } from '../../../../../components/Dropdowns/Dropdowns';
import { dropdownConfig } from '../../../../../services/dropdownsConfigService';
import { HTTP_RESPONSE_CODES } from '../../../../../globals/globals';
import { DialogContext } from '../../../../../contexts/DialogContext';
import { DeleteAircraftTypeIntemModal } from './DeleteAircraftTypeItem/DeleteAircraftTypeIntemModal';
import { deleteAircraftCompatibility } from '../../../services/locationsConfigurationService';
import { useSnackBar } from '../../../../../hooks/useSnackBar';

export const AircraftTypeItem = ({ aircraftData, reloadParent, updateParent }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [data, setData] = useState(aircraftData);
    const [aircraftDropdown, setAircraftDropdown] = useState(null);
    const { openDialog, closeDialog } = useContext(DialogContext);
    const { warningMsg, successMsg , errorMsg } = useSnackBar();
    const [editionMode, setEditionMode] = useState(false);
    const open = Boolean(anchorEl);

    const openDeleteDialog = () => {
        openDialog({
            component: DeleteAircraftTypeIntemModal,
            props: {
                onClose: closeDialog,
                aircraftName: data.aircraftType,
                capacity: data.estimatedCapacity,
                deleteAircraft: deleteThisAircraft
            }
        });
    };

    const deleteThisAircraft = async () => {
        let request = await deleteAircraftCompatibility(data.id);

        if (request.data.responseCode == HTTP_RESPONSE_CODES.DELETED) {
            successMsg("Deleted", "Aircraft Type Deleted");
            closeDialog();
            reloadParent();
        }else{
            errorMsg("Error Deleting" , request.data.message)
        }
    };

    const openPopOver = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const closePopOver = (isCancel = true) => {
        if (isCancel) {
            setData(aircraftData);
            setTimeout(() => {
                setEditionMode(false);
            }, 500);
            setAnchorEl(null);
        }else{
            setTimeout(() => {
                setEditionMode(false);
            }, 500);
            setAnchorEl(null);
        }
    };


    const saveChanges = () => {
        updateParent(data);
        successMsg("Data Updated" , "Save The Changes in The Save Button" , 5000)
        closePopOver(false);
    };


    const getAircraftTypeSelection = (selectedData) => {
        setData(prevState => ({
            ...prevState,
            aircraftType: selectedData.type_name
        }));
    };

    const getDropdownConfigAircraftType = async () => {
        let id = 30;
        const request = await dropdownConfig(id);
        if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
            setAircraftDropdown(request.data.load);
        }
    };

    useEffect(() => {
        getDropdownConfigAircraftType();
    }, []);

    return (
        <section className='AircraftTypeItem-section'>
            <Popover
                anchorEl={anchorEl}
                open={open}
                onClose={closePopOver}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}>
                <div className="popOver-content-site">
                    <h3 className='ellipsis'>+ Add Estimated Aircraft Capacity</h3>
                    <div className="dropdown-aircraftType-cont">
                        {
                            aircraftDropdown && <Dropdowns onOptionSelect={getAircraftTypeSelection} data={aircraftDropdown} />
                        }
                    </div>
                    <section>
                        <p>Estimated Aircraft Capacity</p>
                        <input
                            type="number"
                            value={data.estimatedCapacity}
                            onChange={(e) => {
                                setData(prevState => ({
                                    ...prevState,
                                    estimatedCapacity: e.target.value
                                }));
                            }}
                        />
                    </section>
                    <div className="estimated-aircraft-cap-btn-cont">
                        <button type='button' onClick={saveChanges}>
                            <i className='icon-edit'></i>
                            Edit
                        </button>
                        <button onClick={closePopOver}>
                            <i className='icon-cross' ></i>
                            Cancel
                        </button>
                    </div>
                </div>
            </Popover>
            <p className='ellipsis' style={{ width: "20%" }}>
                Aircraft Type <span>{data?.aircraftType || "--"}</span>
            </p>
            <p>
                Estimated Aircraft Capacity <span>{data?.estimatedCapacity || "--"}</span>
            </p>
            <section>
                <Tooltip title="Edit" arrow>
                    <i
                        className='icon-edit'
                        onClick={(e) => {
                            setEditionMode(true);
                            openPopOver(e);
                        }}
                    ></i>
                </Tooltip>
                <Tooltip title="Delete" arrow>
                    <i className='icon-delete-new' onClick={openDeleteDialog} ></i>
                </Tooltip>
            </section>
        </section>
    );
};